export const types = [
    {
        text: 'Residenziale',
        subtitle: 'Case, Ville, Appartamenti...',
        value: 'residential',
        icon: 'home-icon'
    },
    {
        text: 'Condominio',
        subtitle: 'Gruppi abitativi',
        value: 'condo',
        icon: 'condo-icon'
    },
    {
        text: 'Commerciale',
        subtitle: 'Vendita dettaglio e ingrosso',
        value: 'store',
        icon: 'store-icon'
    },
    {
        text: 'Stabilimento',
        subtitle: 'Aziende, Magazzini, Officine...',
        value: 'factory',
        icon: 'factory-icon'
    },
    {
        text: 'Ufficio',
        subtitle: 'Agenzie, Enti, Studi...',
        value: 'office',
        icon: 'office-icon'
    },
    {
        text: 'Accoglienza',
        subtitle: 'Hotel, Ristoranti, Cliniche...',
        value: 'hospitality',
        icon: 'hotel-icon'
    }
];

// Vectors
export const ELECTRIC_ENERGY = 'ee';
export const GAS = 'gas';

// Consumption types
export const PERIOD_MONTHLY = 'month';
export const PERIOD_YEARLY = 'year';

import contents from "../contents/profile"

export const profileMixin = {
    data() {
        return {
            PERIOD_MONTHLY,
            PERIOD_YEARLY,
            periods: [{
                text: contents.monthly,
                value: PERIOD_MONTHLY
            }, {
                text: contents.yearly,
                value: PERIOD_YEARLY
            }],
        }
    }
};